/*
 * Adds a CookiePolicyWidget class to the Confused namespace.
 * Implemented as IIFE so we can pass in references to the global jQuery, window and document objects.
 * Note: Depends on _partials/Common/v1.0/CookieManager.js being setup at Confused.CookieManager and _core/mi/v1.1/miListener.js (or above) being supported server-side.
 * Adds/ removes '.open' to '.cookie-wall depending on the presence of a CookieConsent cookie, logging the interaction as an MI event and in a cookie
 * Triggers the function triggerGTM() which wraps around the GTM script on page to stop it firing and dropping cookies if CookieConsent cookie is not present
 * Cookie consent cookie name is retrieved from dataLAyer on page and defaults to CookieConsent is dataLayer doesn't have the entry
 */

(function ($, w) {
	'use strict';

	w.Confused = w.Confused || {};
	w.Confused.CookieManager = w.Confused.CookieManager || {};

	w.Confused.CookiePolicyWidget = (function (cookieManager) {
		// GET COOKIE & GTM ID NAME FROM DATALAYER
		var gtmContainerID = window.dataLayer[0].GTMContainer;
		var cookieName = window.dataLayer[0].ConsentCookieName;
		var parent = location.hostname;
		var domainRegex =
			// eslint-disable-next-line
			/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9]))*$/i;
		var miListener = CONFUSEDCORE.MI.MiListener;
		var cookiePopupShown = false;

		if (domainRegex.test(parent)) {
			var parts = parent.split('.');
			parts.shift();
			parent = parts.join('.');
		}

		/* Show widget */
		function showPopup() {
			if (document.querySelector('.cookie-wall')) {
				document.querySelector('.cookie-wall').classList.add('open');
				cookiePopupShown = true;
				//miListener.postEvent('CookiePopupShown');
			}
		}

		// VALIDATE ON BUTTON CLICK THAT THE A CHOICE HAS BEEN MADE
		function validateCookieSelection(btn, event) {
			if ($(btn).parents('.field-group').length > 0) {
				var questionBlock = $(btn).parents('.field-group');

				if ($('.field-group .radio-input:checked').length === 0) {
					event.preventDefault();
					questionBlock.addClass('error');
				} else {
					var selectedRadio = $('.field-group .radio-input:checked').val();
					// IF WE ARE VALIDATING THE COOKIE WALL POPUP
					if ($(btn).hasClass('cookie-wall__button')) {
						if (selectedRadio === 'yes') {
							hidePopup('true', 'CookiePopupDismissed:ConsentGranted');
						}

						if (selectedRadio === 'no') {
							hidePopup('false', 'CookiePopupDismissed:ConsentDeclined');
						}
					}

					// IF WE ARE VALIDATING THE COOKIE POLICY PAGE
					if ($(btn).hasClass('cookie-choice__button')) {
						// SHOW SUCCESS MESSAGE
						document.querySelector('.save-changess-success').classList.remove('hidden');
						// DISABLE BUTTON AS ACTION COMPLETE
						$(btn).addClass('disabled');

						if (selectedRadio === 'yes') {
							updateCookieValue('true');
						}

						if (selectedRadio === 'no') {
							updateCookieValue('false');
						}

						insertGTMScript();

						// HIDE SUCCESS MESSAGE AFTER 5 SECONDS
						setTimeout(function () {
							document.querySelector('.save-changess-success').classList.add('hidden');
						}, 5000);
					}
				}
				// IF COOKIE WALL POPUP ACCEPT ALL BUTTON IS PRESSED
			} else {
				if (document.querySelector('.cookie-wall')) {
					hidePopup('true', 'CookiePopupDismissed:ConsentGranted');
				}
			}
		}

		// REMOVES ERROR CLASS ON FIELDSET HIDING ERROR MESSAGE
		function removeErrorClass() {
			document.querySelector('.field-group').classList.remove('error');
		}

		// CLOSES MODAL
		function closeCookieModal() {
			document.querySelector('.cookie-wall').classList.remove('open');
		}

		/* Hide widget */
		function hidePopup(cookieValue, eventName) {
			cookieManager.setItem(cookieName, cookieValue, 2147483647, '/', parent);

			$(document).trigger('CookieConsentSet', [cookieValue]);

			// INSERT THE GOOGLE TAG MANAGER SCRIPTS TO THE PAGE
			insertGTMScript();

			miListener.postEvent(eventName);

			// CLOSE THE MODAL
			closeCookieModal();
			updateCookieChoiceRadios();
		}

		// SET THE VALUE OF THE EDIT COOKIE PREFERENCES RADIOS ON COOKIE POLICY PAGE
		// BASED ON COOKIE VALUE SELECTED IN POPUP
		function updateCookieChoiceRadios() {
			if (cookieManager.hasItem(cookieName)) {
				if (document.querySelector('.cookie-choice__options')) {
					if (cookieManager.getItem(cookieName) === 'true') {
						document.querySelector('#cookie-choice__input--yes').checked = true;
					} else {
						document.querySelector('#cookie-choice__input--no').checked = true;
					}
					document.querySelector('.cookie-choice__button').classList.add('disabled');
				} else {
					return;
				}
			}
		}

		// UPDATE THE VALUE OF THE COOKIE FROM THE CHOICE MADE ON COOKIE POLICY PAGE
		function updateCookieValue(cookieValue) {
			cookieManager.setItem(cookieName, cookieValue, 2147483647, '/', parent);
		}

		//
		function insertGTMScript() {
			var s = document.createElement('script');
			s.type = 'text/javascript';
			s.async = 'true';
			// CHANGEING THE URL FROM GOOGLE TO OUR SERVERSIDE TAG
			/*s.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmContainerID;*/
			s.src = 'https://sst.confused.com/push?node=' + gtmContainerID;
			var x = document.getElementsByTagName('script')[0];
			x.parentNode.insertBefore(s, x);
		}

		function run() {
			// REGISTER GTM WITH DATALAYER ON LOAD
			// IDEA FOR PROCESS WAS FROM HERE:
			// https://stackoverflow.com/questions/60173853/how-to-set-the-google-analytics-cookie-only-after-another-consent-cookie-is-set/60223798#60223798

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

			if (cookieManager.hasItem(cookieName)) {
				// INSERT THE GOOGLE TAG MANAGER SCRIPTS TO THE PAGE
				insertGTMScript();

				// IF WE ARE ON COOKIE POLICY PAGE AND COOKIE EXISTS WE NEED TO SET THE RADIOS
				// TO THE VALUE OF THE COOKIE
				updateCookieChoiceRadios();
			} else {
				showPopup();
			}

			// SETUP EVENT HANDLERS ON RADIOS & BUTTONS IN COOKIE WALL MODAL
			var buttons = document.querySelectorAll('.save-cookie-prefs');
			var inputs = document.querySelectorAll('.cookie-option-holder .radio-input');

			Array.prototype.forEach.call(buttons, function (button) {
				//buttons.forEach(function (button) {
				button.addEventListener('click', function (event) {
					var btn = event.target;
					validateCookieSelection(btn, event);
				});
			});

			Array.prototype.forEach.call(inputs, function (input) {
				//inputs.forEach(function(input) {
				input.addEventListener('change', function (e) {
					removeErrorClass();
					var radio = e.target;
					if ($(radio).parents('.cookie-choice__input-wrapper') && cookieManager.hasItem(cookieName)) {
						$('.cookie-choice__button').toggleClass('disabled');
					}
				});
			});

			return;
		}

		function wasCookiePopupShown() {
			return cookiePopupShown;
		}

		return {
			run: run,
			wasCookiePopupShown: wasCookiePopupShown,
		};
	})(new w.Confused.CookieManager());
})(window.jQuery, window, document, window.Confused.CookieManager);
